export default "__VITE_ASSET__7398c3f7__"